/* eslint-disable consistent-return */
import api, { STATUSES } from '@/services/api';
import typedDefaults from '@/utils/helpers/typed-defaults';
import { createSingletonLoader, ACTIONS } from '@/store/utils/loader';

export const watchers = [
  // TODO Hybrid - triggers from TKO
  // {
  //   getter: (state) => state.status,
  //   callback: ({ dispatch }, status) => {
  //     if (status === 'unknown') {
  //       dispatch('user/access');
  //     }
  //   },
  //   options: { immediate: true },
  // },
];

export default {
  namespaced: true,
  modules: {
    loader: createSingletonLoader({
      config: {
        reactiveParams: false,
        url: '/me.json',
        params: (state) => ({
          fullprofile: 1,
          getPreferences: 1,
          cleanPreferences: 1,
          includeAuth: 1,
          includeClockIn: 1,
          includeTeamIds: true,
          sharedFilter: state.filter.sharedFilterHash,
          // Backend performance optimization: https://digitalcrew.teamwork.com/app/tasks/23834788
          getNumActiveProjects: false,
        }),
      },
      actions: {
        onLoad({ dispatch, commit }, rs) {
          if (parseInt(rs.data.person.id, 10) <= 0) {
            return dispatch('logout');
          }
          commit('loggedIn', {
            status: 'ok',
            ...rs.data.person,
          });
          commit('preferences/init', { prefs: rs.data.person.preferences, scope: 'user' }, { root: true });
          commit('permissions/init', rs.data.person.permissions, {
            root: true,
          });
          dispatch('getIntegrations');
        },
        [ACTIONS.LOADED_ERROR]({ commit }, error) {
          if (!error.response) {
            commit('loginAgain');
          } else if (error.response.status === STATUSES.CANCELLED) {
            commit('cancelled');
          } else {
            commit('loginAgain');
          }
        },
        // No visible data check, always update the user if the data changes
        // TODO Hybrid
        [ACTIONS.DATA_CHANGE]: ({ dispatch }) => dispatch('hybrid-reload'),
        // eslint-disable-next-line no-undef
        'hybrid-reload': () => app.GetLoggedInUser(),
      },
    }),
  },
  state: {
    status: 'unknown',
    id: 0,
    companyId: 0,
    isClientUser: false,
    inOwnerCompany: false,
    administrator: false,
    siteOwner: false,
    impersonating: false,
    isClockedIn: false,
    isCollaborator: true, // default to true for minimum permissions until we know better
    hasDeskAccount: false,
    hasProjects: false,
    avatarUrl: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    userType: '',
    localization: {
      languageCode: '',
      ellipsis: '',
      startOnSunday: false,
      timeFormat: '',
      dateFormat: '',
      timezoneJavaRefCode: '',
    },
    notifications: {
      soundAlertsEnabled: false,
    },
    auth: {
      token: '',
      timestamp: '',
    },
    accounts: [],
    marketoId: 0,
    integrations: {
      googlecalendar: false,
    },
    integrationBetaFeatures: ['googleCalendar'],
    teamIds: [],
    permissions: {
      canAccessCalendar: false,
      canViewSchedule: false,
      canManageSchedule: false,
      isAdminOnAProject: false,
    },
    ldHash: '',
    creatingProject: false,
  },
  getters: {
    validUser: (state) => state.status === 'ok',
    fullName: (state) => `${state.firstName} ${state.lastName}`,
    isSiteAdmin: (state) => state.inOwnerCompany && state.administrator,
    isAdmin: (state) => state.administrator,
    isClientUser: (state) => state.isClientUser,
    inOwnerCompany: (state) => state.inOwnerCompany,
    isOwnerAdmin: (state) => state.inOwnerCompany && state.administrator,
    isAccount: (state) => state.userType === 'account',
    ellipsis: (state) => state.localization.ellipsis || '...',
    languageCode: (state) => state.localization.languageCode || window.navigator.language,
    timezoneJavaRefCode: (state) => state.localization.timezoneJavaRefCode || '',
    timeFormat: (state) => state.localization.timeFormat.replace('tt', 'A').replace(/hh:mm/i, 'HH:mm'),
    dateFormat: (state) => state.localization.dateFormat.replace('dd', 'DD').replace('mm', 'MM'),
    weekString: (state) => (state.localization.startOnSunday ? 'week' : 'isoweek'),
  },
  mutations: {
    loggedIn(state, person) {
      Object.assign(state, typedDefaults(state, person));
    },
    loginAgain(state) {
      state.status = 'unauthenticated';
    },
    cancelled(state) {
      state.status = 'cancelled';
    },
    loggedOut(state) {
      state.status = 'logged-out';
    },
    setIntegration(state, payload) {
      state.integrations = {
        ...state.integrations,
        [payload.code]: payload.enabled,
      };
    },
    setCreatingProject(state, isCreating) {
      state.creatingProject = isCreating;
    },
  },
  actions: {
    getIntegrations({ commit }) {
      return api
        .get('/synthesis/api/v2/integrations/user.json')
        .then(({ data }) => {
          const { integrations } = data;

          if (!integrations || !integrations.length) {
            return;
          }

          integrations.forEach((integration) => {
            commit('setIntegration', integration);
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    logout({ commit }) {
      return api.put('/v/1/logout.json').then(() => {
        commit('loggedOut');
      });
    },
    cancel({ commit }) {
      commit('cancelled');
    },
    setCreatingProject({ commit }, isCreating) {
      commit('setCreatingProject', isCreating);
    },
  },
};
